import Model from "../../Model";
//import { actions } from '@/store';

class User extends Model{

    buildUrl ({ param }) {
        return ['user', param];
    }
}


export default new User;